import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { Popover, Transition, Dialog } from '@headlessui/react'
import {
    MenuAlt2Icon,
    AdjustmentsIcon,
    PlusIcon
} from '@heroicons/react/outline'
import { SearchIcon, ChevronDownIcon } from '@heroicons/react/solid'

export default function Header(props) {

    function classNames(...classes) {
        return classes.filter(Boolean).join(' ')
    }

    return (

        <div className="sticky top-0 z-10 flex-shrink-0 flex h-16 bg-white shadow">
            <button
                type="button"
                className="px-2 xs:px-4 border-r border-gray-200 text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500 md:hidden"
                onClick={() => props.setSidebarOpen(true)}
            >
                <span className="sr-only">Open sidebar</span>
                <MenuAlt2Icon className="h-6 w-6" aria-hidden="true" />
            </button>
            <div className="flex-1 flex w-full items-center px-2 justify-start">
                {props.search ?
                    <div className="w-full ml-2 sm:ml-8 lg:ml-16">
                        <label htmlFor="search" className="sr-only">
                            Search
                        </label>
                        <div className="relative">
                            <div className="absolute w-full inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                <SearchIcon className="h-5 w-5 text-blue-600" aria-hidden="true" />
                            </div>
                            <input
                                id="search"
                                name="search"
                                onChange={(event) => props.setSearch(event.target.value)}
                                value={props.value}
                                onKeyPress={(event) => event.key === 'Enter' ? props.search() : null}
                                className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                placeholder={props.searchPlaceholder}
                                type="search"
                            />
                        </div>
                    </div>
                    : null
                }
            </div>
            <div className="pl-2 md:pl-6 flex gap-x-2 sm:gap-x-6 items-center">
                {props.Popover ?
                    props.Popover
                    : null}
                {props.filters ?
                    <AdjustmentsIcon onClick={() => props.filters(true)} className="on-hover: cursor-pointer ml-2 h-6 text-blue-600 w-6" aria-hidden="true" />
                    : null}
            </div>
            <div className="flex-1 flex items-center px-2 justify-end">
                {props.buttonText ? <Link
                    to={props.href}
                    className="inline-flex mr-2 sm:mr-8 lg:mr-16 items-center px-4 py-2 border border-transparent shadow-sm text-sm font-semibold rounded-md text-white bg-blue-600 hover:bg-blue-700"
                >
                    <PlusIcon className="-ml-1 mr-2 h-5 w-5" aria-hidden="true" />
                    {props.buttonText}
                </Link>
                    : null}
            </div>
        </div>
    );
}
